var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 398.66 234.62",
    style: {
      enableBackground: "new 0 0 398.66 234.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DA291C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,125.42h12.97v49.79H61.5V125.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.52,125.42h13.32l17.29,30.68h0.14v-30.68h12.2v49.79h-13.32l-17.29-31.03h-0.14v31.03h-12.2V125.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.7,125.42h21.41c15.27,0,24.41,9.27,24.41,24.68c0,16.32-9.27,25.1-24.41,25.1H129.7V125.42z  M142.67,164.05h6.14c9.83-0.21,13.74-4.04,13.74-14.02c0-9.07-4.88-13.46-13.74-13.46h-6.14V164.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.24,125.42h12.97v49.79h-12.97V125.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.14,125.42h13.18l18.62,49.79H233.4l-3.07-8.93h-17.36l-3.14,8.93h-13.32L215.14,125.42z M215.97,156.66 h11.3l-5.51-17.43h-0.14L215.97,156.66z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.22,59.07h15.53l21.94,58.66h-15.94l-3.62-10.52H78.67l-3.7,10.52H59.28L81.22,59.07z M82.21,95.88h13.31 l-6.49-20.54h-0.16L82.21,95.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,59.07h22.51l10.11,39.11h0.16l10.11-39.11h22.51v58.66h-14.38V73.2h-0.16l-12.32,44.53h-11.67 L137.54,73.2h-0.16v44.53H123V59.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.04,59.24h13.24l-20.8,58.6h-13.24L214.04,59.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.55,59.07h15.69l20.38,36.15h0.16V59.07h14.38v58.66h-15.69l-20.38-36.56h-0.16v36.56h-14.38V59.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.51,98.01c0.33,6.9,4.6,9.12,11.09,9.12c4.6,0,9.37-1.64,9.37-6c0-5.18-8.38-6.16-16.84-8.54 c-8.38-2.38-17.17-6.16-17.17-16.92c0-12.82,12.9-17.83,23.91-17.83c11.67,0,23.41,5.67,23.5,18.9h-15.28 c0.25-5.34-4.76-7.07-9.45-7.07c-3.29,0-7.39,1.15-7.39,5.01c0,4.52,8.46,5.34,17.01,7.72c8.46,2.38,17.01,6.33,17.01,16.92 c0,14.87-12.65,19.64-25.55,19.64c-13.47,0-25.39-5.92-25.47-20.95H304.51z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo_red.11b0f5d432298b873a78b3cf15118b31.svg";
export { ForwardRef as ReactComponent };